import React, { useState } from 'react';
import { Download } from '@mui/icons-material';
import { IconButton, Toast } from 'library/ui';
import { Provider } from 'models';
import { getDocumentsFolderForUserId } from './DocumentShared';
import { useUserContext } from 'UserContext';
import DocumentDownloadInfo from 'parent-portal/jobs/upcoming/BusinessCalendar/ShiftCard/DocumentDownloadInfo';

export default function DownloadAllDocuments({ provider }: { provider: Provider }) {
    const { user } = useUserContext();
    const [showDocDownloadInfo, setShowDocDownloadInfo] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const showModal = () => {
        if (user?.address?.[0]?.state === 'Illinois') setShowDocDownloadInfo(!!provider.needs_718b_filing);
    };

    const setLoadingFalse = () => {
        setIsDownloading(false);
    };

    function download() {
        if (isDownloading) return;
        setIsDownloading(true);
        getDocumentsFolderForUserId(provider.user.id, showModal, setLoadingFalse);
    }

    return (
        <>
            <IconButton icon={Download} tooltip="Download all documents" onClick={download} disabled={isDownloading} />
            <Toast message={isDownloading ? 'Preparing documents for download…' : null} />
            <DocumentDownloadInfo
                showDocDownloadInfo={showDocDownloadInfo}
                setShowDocDownloadInfo={setShowDocDownloadInfo}
            />
        </>
    );
}
